import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { Heading } from '../components/heading';

const TermsOfService = () => {
  const [termsContent, setTermsContent] = useState('');

  useEffect(() => {
    fetch('/content/terms-of-service.md')
      .then(response => response.text())
      .then(content => setTermsContent(content))
      .catch(error => console.error('Error loading terms:', error));
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-zinc-900">
      <header className="bg-white shadow-sm dark:bg-zinc-800">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <img src="/ks-logo-full-black.png" alt="KloudStax Logo" className="h-12 w-auto" />
            <img src="/google-cloud-logo.png" alt="Google Cloud Logo" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
        <Heading>Terms of Service</Heading>
        <div className="mt-6 rounded-lg border border-zinc-200 bg-white p-6 prose prose-sm max-w-none dark:prose-invert dark:border-zinc-700 dark:bg-zinc-800">
          <ReactMarkdown className="[&>*:first-child]:mt-0">
            {termsContent}
          </ReactMarkdown>
        </div>
      </main>

      <footer className="bg-white shadow-sm dark:bg-zinc-800 mt-auto">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-zinc-500">
            © 2026 KloudStax. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService; 